import React from "react";
import { useTranslation } from "react-i18next";

export default function CashoutHistoryTableHeaderRow() {
	const { t } = useTranslation("mybets");

	return (
		<tr className="table--primary__header__row">
			<th className="table--primary__header__data u-type--left">
				{t<string>("ITEM.BET_SLIP_COMBINATIONS")}
			</th>
			<th className="table--primary__header__data u-type--left">
				{t<string>("ITEM.INFO_DATE")}
			</th>
			<th className="table--primary__header__data u-type--right">
				{t<string>("ITEM.CASHOUT_VALUE")}
			</th>
		</tr>
	);
}
